// Globals
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { logIn } from '../../feature/actionCreators';
import { selectAuthIsLoading, selectIsAuthorized } from '../../feature/selectors';

// Components
import { LogInForm } from '../../components';
import ResetPasswordModalContainer from '../ResetPasswordModalContainer/ResetPasswordModalContainer';
import ForgotPasswordModalContainer from '../ForgotPasswordModalContainer/ForgotPasswordModalContainer';

// Models
import { ROUTES } from '@/models/router.model';

// Helpers
import { TLogInFormValues } from '../../helpers/types';
import LoginDTO from '../../dtos/LoginDTO';
import { useModal, useQueryParams } from '@/hooks';
import { QUERY_PARAMS } from '@/constants/cookies';

const SignInContainer = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectAuthIsLoading);
  const isAuthorized = useAppState(selectIsAuthorized);
  const token = useQueryParams(QUERY_PARAMS.TOKEN);
  const email = useQueryParams(QUERY_PARAMS.EMAIL);
  const navigate = useNavigate();

  const { isOpened: isResetPasswordOpened, openModal: openResetPassword, closeModal: closeResetPassword } = useModal();
  const {
    isOpened: isForgotPasswordOpened,
    openModal: openForgotPassword,
    closeModal: closeForgotPassword,
  } = useModal();

  const handleSubmit = useCallback(
    (values: TLogInFormValues) => {
      const loginDto = new LoginDTO(values);
      dispatch(logIn(loginDto));
    },
    [dispatch],
  );

  useEffect(() => {
    if (token && email) {
      openResetPassword();
    }
  }, [openResetPassword, token, email]);

  useEffect(() => {
    if (isAuthorized) navigate(ROUTES.PROFILE);
  }, [isAuthorized, navigate]);

  return (
    <>
      <LogInForm handleSubmit={handleSubmit} isLoading={isLoading} openForgotPassword={openForgotPassword} />
      <ResetPasswordModalContainer
        isOpened={isResetPasswordOpened}
        onClose={closeResetPassword}
        email={email as string}
        token={token as string}
      />
      <ForgotPasswordModalContainer isOpened={isForgotPasswordOpened} onClose={closeForgotPassword} />
    </>
  );
};

export default SignInContainer;
